import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// Start each newly visited page at the top.
//
// Moving between pages here swaps content without a page load, so the browser
// keeps the window's scroll position: scroll down Home, click Notepad Blog, and
// the blog list opened just as far down — past its newest article.
//
// Left alone on purpose:
// - Back / Forward (a POP): the browser returns the reader to where they were.
// - URLs with a #hash: the page scrolls to that FAQ question or section itself.
// - Query-string-only changes (Governing Documents filters and search): the
//   path is unchanged, so the effect doesn't run.
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  // Layout effect, so the jump happens before paint rather than as a visible
  // flash of the old position.
  useLayoutEffect(() => {
    if (navigationType === 'POP' || hash) return;
    window.scrollTo(0, 0);
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}

export default ScrollToTop;
